import type { Feature } from '@luna/gatekeeper';

export const georgeIdMigrationTour: Feature = {
    enabled: false,
};
